<template>
  <header>
    <div class="top-nav"></div>
    <div class="container">
      <div class="navbar">
        <div class="logo d-flex align-items-center">
          <nuxt-link to="/">
            <img class="logo" src="/logo.png" />
          </nuxt-link>
          <div class="border-r-2 ps-3">
            <div class="header-text text-nowrap">
              <!-- {{ $t("Company-Name") }} -->
              Plastics
            </div>
          </div>
        </div>
        <!-- MOBILE COMPONENT -->
        <span
          class="toggler d-flex d-xl-none"
          :class="{ crossed: isMobileNavActive }"
          @click="toggleNavbar"
        ></span>
        <!-- MOBILE COMPONENT -->
        <nav class="main-nav d-none d-xl-block">
          <ul>
            <li class="has-sub-menu">
              <nuxt-link to="/about-nagase">About NAGASE</nuxt-link>
            </li>
            <li class="has-sub-menu">
              <nuxt-link to="/products">Products</nuxt-link>
              <i class="fas fa-angle-down"></i>
              <div class="sub-menu">
                <ul>
                  <li>
                    <nuxt-link to="/products/high-performance-plastics"
                      >High Performance Plastics</nuxt-link
                    >
                  </li>
                  <li>
                    <nuxt-link to="/products/sustainable-plastics"
                      >Sustainable Plastics</nuxt-link
                    >
                  </li>
                  <li>
                    <nuxt-link to="/products/engineering-plastics"
                      >Engineering Plastics</nuxt-link
                    >
                  </li>
                  <li>
                    <nuxt-link to="/products/commodity-plastics"
                      >Commodity Plastics</nuxt-link
                    >
                  </li>
                </ul>
              </div>
            </li>
            <li class="has-sub-menu">
              <nuxt-link to="/services">Services</nuxt-link>
              <i class="fas fa-angle-down"></i>
              <div class="sub-menu">
                <ul class="sub-nav">
                  <li>
                    <nuxt-link
                      to="/services/material-selection-products-development-support"
                      >Material Selection & Products Development Support
                    </nuxt-link>
                  </li>
                  <li>
                    <nuxt-link
                      to="/services/co2-calculation-visualization-service-by-zero-board"
                      >CO2 Calculation & Visualization Service by Zero Board
                    </nuxt-link>
                  </li>
                  <li>
                    <nuxt-link to="/services/technical-troubleshooting"
                      >Technical Troubleshooting</nuxt-link
                    >
                  </li>
                  <li>
                    <nuxt-link to="/services/logistics-supports"
                      >Logistics Supports</nuxt-link
                    >
                  </li>
                </ul>
              </div>
            </li>
            <li class="has-sub-menu">
              <nuxt-link to="/industries">Industries</nuxt-link>
              <i class="fas fa-angle-down"></i>
              <div class="sub-menu">
                <ul class="sub-nav">
                  <li>
                    <nuxt-link to="/industries/automotive-and-e-mobility"
                      >Automotive and E-mobility</nuxt-link
                    >
                  </li>
                  <li>
                    <nuxt-link to="/industries/electrical-electronics"
                      >Electrical & Electronics</nuxt-link
                    >
                  </li>
                  <li>
                    <nuxt-link to="/industries/office-automation"
                      >Office Automation</nuxt-link
                    >
                  </li>
                  <li>
                    <nuxt-link to="/industries/home-appliances"
                      >Home Appliances</nuxt-link
                    >
                  </li>
                  <li>
                    <nuxt-link to="/industries/medical-devices"
                      >Medical Devices</nuxt-link
                    >
                  </li>
                  <li>
                    <nuxt-link to="/industries/infrastructure"
                      >Infrastructure</nuxt-link
                    >
                  </li>
                </ul>
              </div>
            </li>
            <li>
              <nuxt-link to="/use-cases">Use Cases</nuxt-link>
            </li>
            <li>
              <nuxt-link to="/sustainability">Sustainability</nuxt-link>
            </li>
            <li>
              <nuxt-link to="/contact-us" class="btn-contact-us">
                Contact us
              </nuxt-link>
            </li>
          </ul>
        </nav>
      </div>
    </div>
    <div class="content d-none d-xl-block"></div>
    <div
      class="side-navbar d-flex d-xl-none"
      :class="{ active: isMobileNavActive }"
    >
      <nav class="toggle-nav d-xl-none">
        <div class="content">
          <div class="container">
            <ul>
              <li class="divider spacing">
                <nuxt-link
                  to="/about-nagase"
                  @click="(e) => handleNavBarDismiss(e)"
                >
                  <div class="custom-line-height">
                    <span>About NAGASE</span>
                  </div>
                </nuxt-link>
              </li>
              <li class="has-sub-nav divider spacing">
                <nuxt-link
                  to="/products"
                  @click="(e) => handleNavBarDismiss(e)"
                >
                  <div class="custom-line-height">
                    <span>Products</span>
                  </div>
                  <span
                    class="sub-nav-toggler"
                    @click="(e) => handleMobileNavbarHasSubNavClick(e)"
                  >
                    <i class="fas fa-angle-down pe-none"></i>
                  </span>
                </nuxt-link>

                <ul class="sub-nav">
                  <li>
                    <nuxt-link
                      to="/products/high-performance-plastics"
                      @click="(e) => handleNavBarDismiss(e)"
                      >High Performance Plastics</nuxt-link
                    >
                  </li>
                  <li>
                    <nuxt-link
                      to="/products/sustainable-plastics"
                      @click="(e) => handleNavBarDismiss(e)"
                      >Sustainable Plastics</nuxt-link
                    >
                  </li>
                  <li>
                    <nuxt-link
                      to="/products/engineering-plastics"
                      @click="(e) => handleNavBarDismiss(e)"
                      >Engineering Plastics</nuxt-link
                    >
                  </li>
                  <li>
                    <nuxt-link
                      to="/products/commodity-plastics"
                      @click="(e) => handleNavBarDismiss(e)"
                      >Commodity Plastics</nuxt-link
                    >
                  </li>
                </ul>
              </li>
              <li class="has-sub-nav divider spacing">
                <nuxt-link
                  to="/services"
                  @click="(e) => handleNavBarDismiss(e)"
                >
                  <div class="custom-line-height">
                    <span>Services</span>
                  </div>
                  <span
                    class="sub-nav-toggler"
                    @click="(e) => handleMobileNavbarHasSubNavClick(e)"
                  >
                    <i class="fas fa-angle-down pe-none"></i>
                  </span>
                </nuxt-link>

                <ul class="sub-nav">
                  <li>
                    <nuxt-link
                      to="/services/material-selection-products-development-support"
                      @click="(e) => handleNavBarDismiss(e)"
                      >Material Selection & Products Development Support
                    </nuxt-link>
                  </li>
                  <li>
                    <nuxt-link
                      to="/services/co2-calculation-visualization-service-by-zero-board"
                      @click="(e) => handleNavBarDismiss(e)"
                      >CO2 Calculation & Visualization Service by Zero Board
                    </nuxt-link>
                  </li>
                  <li>
                    <nuxt-link
                      to="/services/technical-troubleshooting"
                      @click="(e) => handleNavBarDismiss(e)"
                      >Technical Troubleshooting</nuxt-link
                    >
                  </li>
                  <li>
                    <nuxt-link
                      to="/services/logistics-supports"
                      @click="(e) => handleNavBarDismiss(e)"
                      >Logistics Supports</nuxt-link
                    >
                  </li>
                </ul>
              </li>
              <li class="divider spacing">
                <nuxt-link
                  to="/use-cases"
                  @click="(e) => handleNavBarDismiss(e)"
                >
                  <div class="custom-line-height">
                    <span>Use Cases</span>
                  </div>
                  <span class="sub-nav-toggler"> </span>
                </nuxt-link>
              </li>
              <li class="divider spacing">
                <nuxt-link
                  to="/sustainability"
                  @click="(e) => handleNavBarDismiss(e)"
                >
                  <div class="custom-line-height">
                    <span>Sustainability</span>
                  </div>
                  <span class="sub-nav-toggler"> </span>
                </nuxt-link>
              </li>
              <li class="spacing">
                <nuxt-link
                  to="/contact-us"
                  @click="(e) => handleNavBarDismiss(e)"
                >
                  <div class="custom-line-height">
                    <span>Contact Us</span>
                  </div>
                </nuxt-link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </div>
  </header>
</template>

<script setup>
// TOGLLER
const isMobileNavActive = useState("isMobileNavActive", () => false);

const handleNavBarDismiss = (event) => {
  if (!event.target.classList.contains("sub-nav-toggler")) {
    isMobileNavActive.value = true;
    toggleNavbar();
  }
};

const toggleNavbar = () => {
  const toggleNav = document.querySelector("header .toggle-nav");

  if (isMobileNavActive.value) {
    isMobileNavActive.value = false;

    toggleNav.style.height = "auto";
    const height = `${toggleNav.clientHeight}px`;
    toggleNav.style.height = height;

    toggleNav.addEventListener(
      "transitionend",
      () => {
        toggleNav.classList.remove("active");
      },
      { once: true },
    );

    setTimeout(() => {
      toggleNav.style.height = "0px";
    }, 0);
  } else {
    isMobileNavActive.value = true;

    toggleNav.style.height = "auto";
    toggleNav.classList.add("active");
    const height = `${toggleNav.clientHeight}px`;

    toggleNav.style.height = "0px";

    toggleNav.addEventListener(
      "transitionend",
      () => {
        toggleNav.style.height = "auto";
      },
      { once: true },
    );

    setTimeout(() => {
      toggleNav.style.height = height;
    }, 0);
  }
};
const mobileNavbarDismiss = (target) => {
  const toggleNav = target.closest(".toggle-nav");
  const subnavs = toggleNav.querySelectorAll(".sub-nav.active");
  const subnavTogglers = toggleNav.querySelectorAll(".sub-nav-toggler.active");

  setTimeout(() => {
    for (const subnav of subnavs) {
      subnav.style.height = "0px";

      const parentSubnav = subnav.closest(".has-sub-nav");
      parentSubnav.classList.remove("active");

      subnav.addEventListener(
        "transitionend",
        () => {
          subnav.classList.remove("active");
        },
        { once: true },
      );
    }

    for (const subnavToggler of subnavTogglers) {
      subnavToggler.classList.remove("active");
    }
  }, 0);
};
const handleMobileNavbarHasSubNavClick = (event) => {
  event.preventDefault();

  const target = event.target;

  const parentSubnav = target.closest(".has-sub-nav");
  const subnav = parentSubnav.querySelector(".sub-nav");

  if (subnav.classList.contains("active")) {
    target.classList.remove("active");
    parentSubnav.classList.remove("active");
    subnav.style.height = "0px";

    subnav.addEventListener(
      "transitionend",
      () => {
        subnav.classList.remove("active");
      },
      { once: true },
    );
  } else {
    mobileNavbarDismiss(target);

    target.classList.add("active");
    subnav.classList.add("active");
    parentSubnav.classList.add("active");
    subnav.style.height = "auto";

    const height = `${subnav.clientHeight}px`;

    subnav.style.height = "0px";

    setTimeout(() => {
      subnav.style.height = height;
    }, 0);
  }
};

function scrolldownToEnduser() {
  window.scrollTo(0, 520);
}
</script>
<style scoped>
.dropdown-menu.dropdown-menu-end.show {
  z-index: 1300;
  top: 0px;
}
.border-r-2 {
  border-left: #e7e7e7 solid 2px;
}
</style>
<style>
header {
  position: sticky;
  top: 0;
  z-index: 99999;
}
</style>
